import styles from "../../pages/AgencyRecommendations/styles.module.sass";
import { FaMapMarkerAlt } from "react-icons/fa";
import cn from "classnames";
import format from "date-fns/format";
import { AiFillCloseCircle } from "react-icons/ai";
import {
  mapPropertyType,
  replaceCharacters,
} from "../../utils/filter-transforms";

export function setAgencyRecommendationsColumns(
  columnHelper,
  mappedProperties,
  deleteAgencyRecommendation
) {
  if (!mappedProperties || mappedProperties.length === 0) {
    return [];
  }
  return [
    columnHelper.accessor("propertyCode", {
      cell: (info) => {
        const property = mappedProperties?.[info.row.id];
        if (!property) return null;
        return (
          <a
            className={styles.introCell}
            href={`${
              import.meta.env.VITE_APP_FRONTEND_APP_LINK
            }/${mapPropertyType(property.type)}/${replaceCharacters(
              property.city
            )}${property.area && "-" + replaceCharacters(property.area)}/${
              property.property_code
            }`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <div>Šifra: {property.property_code}</div>
            <div>Tip: {property.type}</div>
          </a>
        );
      },
      header: () => "",
    }),
    columnHelper.accessor("location", {
      cell: (info) => {
        const property = mappedProperties?.[info.row.id];
        if (!property) return null;
        return (
          <div className={styles.location}>
            <div>
              <FaMapMarkerAlt />
              {property.city}, {property.area}
            </div>
            <div className="d-flex">
              <div className={styles.box}>{property.propertySize}m2</div>
              <div className={cn(styles.box, styles.price)}>
                {property.price}€
              </div>
            </div>
          </div>
        );
      },
      header: () => "",
    }),
    columnHelper.accessor("created", {
      cell: (info) => {
        const property = mappedProperties?.[info.row.id];
        if (!property) return null;
        return (
          <div className={styles.created}>
            <div>Vreme dodavanja nekretnine:</div>
            {property.date && (
              <div>
                {format(new Date(property.date), "yyyy-MM-dd HH:mm:ss")}
              </div>
            )}
            <div
              className={cn(styles.infoBox, {
                [styles.grey]: !property.contract,
              })}
            >
              Ugovor
            </div>
            <div
              className={cn(styles.infoBox, {
                [styles.grey]: !property.publish,
              })}
            >
              Odobrena
            </div>
          </div>
        );
      },
      header: () => "",
    }),
    columnHelper.accessor("operations", {
      cell: (info) => {
        const property = mappedProperties?.[info.row.id];
        if (!property) return null;
        return (
          <div className={styles.actionsContainer}>
            <div className={cn(styles.actionItem, {})}>
              <button
                className={cn(styles.iconButton, {})}
                onClick={() => deleteAgencyRecommendation(property.propertyId)}
              >
                <AiFillCloseCircle />
              </button>
              <div className={styles.text}>Ukloni</div>
            </div>
          </div>
        );
      },
      header: () => "",
    }),
  ];
}
